// extracted by mini-css-extract-plugin
export default {"ActionList_LinkItem":"LinkedPullRequests-module__ActionList_LinkItem__P5a77rI"};